import Product from './DictionaryOfPermission/Product';
import ProductDetail from './DictionaryOfPermission/ProductDetail';
import Dashboard from './DictionaryOfPermission/Dashboard';
import CompareProduct from './DictionaryOfPermission/CompareProduct';
import Alerts from './DictionaryOfPermission/Alerts';
import BOM from './DictionaryOfPermission/BOM';
import Checkout from './DictionaryOfPermission/Checkout';
import Forecast from "./DictionaryOfPermission/Forecast";
import Order from "./DictionaryOfPermission/Order";
import Quote from './DictionaryOfPermission/Quote';

class ExternalSales {

    static register = {
        ...Product.register,
        ...Forecast.register,
        ...ProductDetail.register,
        ...Dashboard.register,
        ...CompareProduct.register,
        ...Alerts.register,
        ...BOM.register,
        ...{[Checkout.register_internal.CKOT_VIEW.slug]: Checkout.register_internal.CKOT_VIEW},
        ...{[Checkout.register_internal.CKOT_ORDER_PLACED_BOX.slug]: Checkout.register_internal.CKOT_ORDER_PLACED_BOX},
        ...Order.register,
        ...Quote.register
    };

    static avUserInfoName = 'External Sales';
}

export default ExternalSales;